import OfferIdlePromptModal from '@/features/offers/components/Modal/OfferIdlePromptModal'
import { useCallback, useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom'

import config from '@/config'
const OfferIdleCheckingProvider = ({ children }) => {
  const timeoutMs = Number(config.offerTimeOutTime) || 0
  const promptBeforeIdleMs = Number(config.offerIdlePromptTime) || 0
  const idleTimeMs = Math.max(timeoutMs - promptBeforeIdleMs, 0)
  const timeoutSeconds = Math.ceil(timeoutMs / 1000)

  const [idleRemainingTime, setIdleRemainingTime] = useState(timeoutSeconds)
  const [showIdlePrompt, setShowIdlePrompt] = useState(false)

  //Hooks

  const navigate = useNavigate()

  const { getRemainingTime, activate } = useIdleTimer({
    onPrompt: () => {
      setShowIdlePrompt(true)
    },
    onIdle: () => {
      setShowIdlePrompt(false)
      navigate('/offers/my')
    },
    promptBeforeIdle: promptBeforeIdleMs,
    timeout: timeoutMs,
    throttle: 1000,
  })

  const handleConfirmStillHere = useCallback(() => {
    activate()
    setShowIdlePrompt(false)
  }, [activate])

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = Math.ceil(getRemainingTime() / 1000)
      setIdleRemainingTime(remainingTime)
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [getRemainingTime, showIdlePrompt, timeoutSeconds])

  return (
    <>
      <OfferIdlePromptModal
        idleTime={idleTimeMs}
        remainingTime={idleRemainingTime}
        isOpened={showIdlePrompt}
        handleConfirmStillHere={handleConfirmStillHere}
      />
      {children}
    </>
  )
}

export default OfferIdleCheckingProvider
